import { z } from "zod";
import { zBulkPlanCreation } from "./BulkPlanCreationTypes";

const zBulkPlanCreationStep = zBulkPlanCreation.omit({
  entityIds: true,
  templateEntityId: true,
});
export type ZBulkPlanCreationStep = z.infer<typeof zBulkPlanCreationStep>;

export type EdBulkPlanCreation = Omit<ZBulkPlanCreationStep, "newStartDate"> & {
  newStartDate?: string[] | null;
};

export const edit2BulkPlanCreation = (
  data: EdBulkPlanCreation,
): ZBulkPlanCreationStep =>
  zBulkPlanCreationStep.parse({
    ...data,
    newStartDate: data.newStartDate?.[0],
  });
